module.exports = __webpack_public_path__ + "mt.svg?7893921d36e78a4d12001a42115e20a6";